export interface ComputedRecordLike {
    id: string;
    recordType: string;
    recordValue: Record<string, unknown>;
    confidenceScore?: string;
    lastVerifiedAt?: string | null;
    createdAt?: string;
}

export type RecordTypeI18nPrefix = 'factTypes' | 'signalTypes';

export const SIGNAL_METADATA_KEYS = new Set(['extractor', 'source']);

export function recordDisplayValue(
    value: Record<string, unknown>,
): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    for (const [key, entry] of Object.entries(value)) {
        if (!SIGNAL_METADATA_KEYS.has(key)) {
            out[key] = entry;
        }
    }
    return out;
}

export function signalSource(value: Record<string, unknown>): string | null {
    const extractor = value.extractor;
    if (typeof extractor === 'string' && extractor.trim()) {
        return extractor;
    }
    const source = value.source;
    if (typeof source === 'string' && source.trim()) {
        return source;
    }
    return null;
}
